module.exports = __webpack_public_path__ + "img/balblue.3e76c8bc.svg";